import React from 'react'

import Link from './Common/Link'

import getRoutes from '@/lib/getRoutes'

import COLORS from '@/src/colors'
import FONTS from '@/src/fonts'
import { LinkOutlined } from '@mui/icons-material'

type ProductCompany = {
  id?: any
  name?: any
  company_seo_name?: string
  company_name?: string
  company_id?: string | number
}
type Props = {
  object: ProductCompany
  forceLink?: {
    href: string
    as: string
  }
  style?: Record<string, string | number>
}

const CompanyName: React.FC<Props> = ({ object, forceLink, style = {} }) => {
  const urlCompany = getRoutes({
    route: 'Company',
    values: { '[slug]': object.company_seo_name ?? object.company_id ?? object.id },
  })

  return (
    <Link
      href={forceLink?.href || urlCompany.href}
      as={forceLink?.as || urlCompany.as}
      style={{
        color: COLORS.vendor,
        fontWeight: FONTS.WEIGHT.BOLD,
        width: 'fit-content',
        ...style,
      }}
    >
      <span className="group flex items-end relative w-fit h-fit hover:underline">
        <div>{object.company_name ?? object.name}</div>
        <div className="flex items-end transition-opacity opacity-0 group-hover:opacity-100 absolute bottom-0 -right-6">
          <LinkOutlined className="text-gray-500" fontSize="small" />
        </div>
      </span>
    </Link>
  )
}

export default CompanyName
